import {
  GetParameter,
  BootstrapRepositoryInterface,
} from "./bootstrap.repository.d";
import { BaseRepository } from "../Base/base.repository";
import { BootstrapEntity } from "./bootstrap.entity";
import { ServerlessConfigure } from "../../config/serverless-configure";

export class BootstrapRepository
  extends BaseRepository<BootstrapEntity>
  implements BootstrapRepositoryInterface
{
  constructor() {
    super(
      {
        baseURL: ServerlessConfigure.ApiEndpoint,
      },
      {
        hasSendToken: false,
      },
    );
  }

  async get(params: GetParameter) {
    const { tenantId } = params;
    const response = await this.apiRequest.get({
      url: `/bootstrap/${tenantId}`,
    });
    return response.data;
  }

  async getList() {
    const response = await this.apiRequest.getList({ url: "/bootstrap" });
    return response.data.Items;
  }
}
